const blacklistRegex = new RegExp(/[^0-9a-zA-Z\f\n\r\t\v\$\(\)\*\+\.\?\\\^\{\}\[\]\u0022 !#%&'-/@_`:~\u2019\u2013]/);

export default blacklistRegex;